import { callOutAmountForUrgency } from './callOutFeeDisplay';

/** A fee digit we already have. Zero and missing amounts are omitted, not shown as ₹0. */
export function knownCallOutFee(raw) {
  if (typeof raw !== 'number' || !Number.isFinite(raw) || raw <= 0) return null;
  return raw;
}

/**
 * Navigation state for an existing booking entry.
 * Urgency and fee are copied only when the caller already has them.
 * A service with its own call-out fields uses that amount; it does not borrow another price.
 */
export function bookingNavigationState({
  service = null,
  intent = null,
  selectedAddress = null,
  serviceLabel = null,
} = {}) {
  const urgency = intent?.urgency || null;
  let fee = null;
  if (urgency) {
    if (service?.pricing?.callOutFee) {
      fee = callOutAmountForUrgency(service.pricing.callOutFee, urgency);
    } else {
      fee = knownCallOutFee(intent?.callOutFee);
    }
  }

  const state = {};
  if (serviceLabel) state.serviceLabel = serviceLabel;
  if (urgency) state.urgency = urgency;
  if (fee != null) state.callOutFee = fee;
  if (selectedAddress) state.selectedAddress = selectedAddress;
  return state;
}
